/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { DgExerciseCustomerResponseFromJSON, DgExerciseCustomerResponseToJSON, } from './DgExerciseCustomerResponse.js';
import { PartnerInformationFromJSON, PartnerInformationToJSON, } from './PartnerInformation.js';
/**
 * Check if a given object implements the CheckDgContractVerificationCodeResponse interface.
 */
export function instanceOfCheckDgContractVerificationCodeResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "compliant" in value;
    isInstance = isInstance && "contractId" in value;
    isInstance = isInstance && "contractCoveragePercentage" in value;
    return isInstance;
}
export function CheckDgContractVerificationCodeResponseFromJSON(json) {
    return CheckDgContractVerificationCodeResponseFromJSONTyped(json, false);
}
export function CheckDgContractVerificationCodeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'compliant': json['compliant'],
        'contractId': json['contract_id'],
        'contractCoveragePercentage': json['contract_coverage_percentage'],
        'exerciseSessionId': !exists(json, 'exercise_session_id') ? undefined : json['exercise_session_id'],
        'exercise': !exists(json, 'exercise') ? undefined : DgExerciseCustomerResponseFromJSON(json['exercise']),
        'partner': !exists(json, 'partner') ? undefined : PartnerInformationFromJSON(json['partner']),
        'minMinutesDelay': !exists(json, 'min_minutes_delay') ? undefined : json['min_minutes_delay'],
        'maxHoursBeforeDeparture': !exists(json, 'max_hours_before_departure') ? undefined : json['max_hours_before_departure'],
        'serviceCap': !exists(json, 'service_cap') ? undefined : json['service_cap'],
    };
}
export function CheckDgContractVerificationCodeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'compliant': value.compliant,
        'contract_id': value.contractId,
        'contract_coverage_percentage': value.contractCoveragePercentage,
        'exercise_session_id': value.exerciseSessionId,
        'exercise': DgExerciseCustomerResponseToJSON(value.exercise),
        'partner': PartnerInformationToJSON(value.partner),
        'min_minutes_delay': value.minMinutesDelay,
        'max_hours_before_departure': value.maxHoursBeforeDeparture,
        'service_cap': value.serviceCap,
    };
}
